// extracted by mini-css-extract-plugin
export default {"image":"wZ-z","loaded":"xZ-z"};